module.exports = __webpack_public_path__ + "img/Fashion, Textiles & Fabrics.08cce602.png";